// extracted by mini-css-extract-plugin
export default {"tapianBtns":"QuanwenBtns_tapianBtns__nt2EG","tapianBtnsEn":"QuanwenBtns_tapianBtnsEn__Nj-TE","tapianBtnsEnMo":"QuanwenBtns_tapianBtnsEnMo__e7sev"};